class Debug {

    /** Debug.js
     * Displays debug overlay when $_GET['debug'] is true.
     *
     */
    constructor(options) {
        console.log('Simplestream::Debug::constructor()');

        // Validate options
        if(!options.parent) {
            console.error('Simplestream::Debug: Missing parent');
            return;
        } else if(!options.container) {
            console.error('Simplestream::Debug: Missing container');
            return;
        } else if(!options.videoElement) {
            console.error('Simplestream::Debug: Missing videoElement');
            return;
        }

        // Set options
        this.parent = options.parent;
        this.container = options.container;
        this.videoElement = options.videoElement;

        this.init();
    }

    /**
     * Initialise the debug container.
     */
    init() {
        const htmlContent = `
        <div id="debug" class="debug-container">
            <div>Simplestream Media Player (SSMP) Debug<div>
            <div>
                <div>
                    <p>Embed Code Attributes:</p>
                    <p id="embedCodeAttributes"></p>
                </div>
                <div>
                    <p>Video Element Attributes:</p>
                    <p id="videoElementAttributes"></p>
                </div>
            </div>
        </div>`;
        this.container.insertAdjacentHTML('beforeend', htmlContent);

        this.debugElement = document.getElementById('debug');

        // Check if the 'Ctrl' key and the 'D' key are pressed
        this.videoElement.addEventListener('timeupdate', (event) => {
            this.refreshData();
        });

        // Check if the 'Ctrl' key and the 'D' key are pressed
        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey && event.key === 'd') {
                event.preventDefault();
                if (this.debugElement.style.display === 'none' || this.debugElement.style.display === '') {
                    this.debugElement.style.display = 'block';
                } else {
                    this.debugElement.style.display = 'none';
                }
            }
        });
    }

    refreshData() {
        this.getAttributes();
    }

    getAttributes() {
        var attributes = '';
        var entries = Object.entries(this.parent.container.dataset);
        entries.forEach(([key, value]) => {
            attributes += `<p>${key}: ${value}</p>`;
        });
        document.getElementById('embedCodeAttributes').innerHTML = attributes;

        var attributes = '';
        var entries = Object.entries(this.parent.videoElement.dataset);
        entries.forEach(([key, value]) => {
            attributes += `<p>${key}: ${value}</p>`;
        });
        document.getElementById('videoElementAttributes').innerHTML = attributes;
    }
}

export default Debug;